/* KINNIKU TIMES — PCレイアウトの余白調整
   2026-10-28: 注目記事の閲覧数ランキングとリアルタイム閲覧数を削除した
   （集計のAPIが常にタイムアウトして失敗していたため。オーナー指示）。
   残っているのは、PC幅でサイドバーの方が長いと左側に空白ができるのを、
   ページ下のカテゴリ枠を左カラムへ順に移して高さをそろえる処理だけ。 */
(function () {
  function balance() {
    if (window.innerWidth < 990) return;
    var main = document.querySelector('.kt-main');
    var aside = main && main.querySelector('.kt-aside');
    var left = main && main.firstElementChild;
    if (!main || !aside || !left || left === aside) return;
    var guard = 0;
    while (guard++ < 30) {
      var next = main.nextElementSibling;
      while (next && (next.tagName === 'LINK' || next.tagName === 'SCRIPT' || next.tagName === 'STYLE')) next = next.nextElementSibling;
      if (!next) break;
      /* 大会スケジュールやページ送りなど、ページ下にあるべきものは動かさない */
      if (next.classList.contains('kt-pager') || /大会スケジュール/.test(next.getAttribute('aria-label') || '')) break;
      if (!(next.classList.contains('kt-block') || next.classList.contains('kt-promo'))) break;
      var gap = aside.getBoundingClientRect().bottom - left.getBoundingClientRect().bottom;
      var h = next.getBoundingClientRect().height + 48;
      if (gap < h * 0.6) break;
      left.appendChild(next);
      next.classList.add('kt-moved');
    }
  }

  setTimeout(balance, 50);
  window.addEventListener('load', function () { setTimeout(balance, 300); });
})();
